import { useState, useEffect } from 'react';
import { gridTheme } from '@utils/grid';
import { debounce } from 'debounce';

export const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const updateIsDesktop = () => {
      setIsDesktop(window.innerWidth > gridTheme.breakpoints.xl);
    };

    updateIsDesktop();

    const debouncedUpdateIsDesktop = debounce(updateIsDesktop, 100);

    window.addEventListener('resize', debouncedUpdateIsDesktop);

    return () => {
      window.removeEventListener('resize', debouncedUpdateIsDesktop);
    };
  }, []);

  return isDesktop;
};
